import { render, staticRenderFns } from "./refuse.vue?vue&type=template&id=4510b2e2&scoped=true&"
import script from "./refuse.vue?vue&type=script&lang=js&"
export * from "./refuse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4510b2e2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\www\\ssz_gold_backend\\multi_merchant_web\\gold_admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4510b2e2')) {
      api.createRecord('4510b2e2', component.options)
    } else {
      api.reload('4510b2e2', component.options)
    }
    module.hot.accept("./refuse.vue?vue&type=template&id=4510b2e2&scoped=true&", function () {
      api.rerender('4510b2e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/finance/withdrawal/refuse.vue"
export default component.exports